import type { LegacyReaderOpenOptions } from '../../legacy/legacyGlobals';
import { mountExtractedScreen, unmountExtractedScreen } from '../../legacy/screenHost';
import { createLegacyReaderHost, type ReaderHost } from './readerHost';
import { ReaderScreen } from './ReaderScreen';

/**
 * The React replacement for legacy openReader: same preparation (script data,
 * then the page's tajweed font), same delegation of full-page mode to the
 * still-legacy openMushaf, then the React screen mounted into #app.
 */
export async function openReaderScreen(opts?: LegacyReaderOpenOptions, host: ReaderHost = createLegacyReaderHost()): Promise<void> {
  try {
    await host.ensureScriptData();
    const prefs = host.prefs();
    if (prefs.mode === 'full') { unmountExtractedScreen(); host.openMushaf(opts); return; }
    const page = host.currentPage();
    if (prefs.script === 'uthmani' && prefs.tajweed) await host.loadPageFont(page);
    mountExtractedScreen(<ReaderScreen host={host} page={page} onReady={opts?.onReady} />);
  } catch (error: unknown) {
    console.error('openReader', error);
  }
}
